<template>
  <div class="map-pc">
    <div class="amap-wrapper" style="width:66.66666%; height: 100vh">
      <iframe style="width: 100%;height: 100%;" :src="src" frameborder="no" framespacing="0" scrolling="no" allow="autoplay; encrypted-media" allowfullscreen="true"></iframe>
    </div>
    <div class="arrive_list" :style="{width:'33.33333%',height: '100vh', 'background-color': color}">
      <div class="head">
        <img :src="headerImg" />
      </div>
      <div class="body">
        <div
          v-for="(group, index) in l_time_list"
          :key="index"
          class="item"
          :style="{'color': color}"
          :class="`${index != 0 && index % 2 == 0 ? 'even' : ''} ${index == 0 ? 'first' : ''}`"
        >
          <!-- {{ group.info.numberid1 }} -->
          <div v-if="index == 0" class="img"></div>
          <div class="info">
            <div class="g-name">{{ group.info.unit }}</div>
            <div class="g-num">{{ group.info.ename }}</div>
          </div>
          <div class="l-time">{{ group.info.numberid1 }}</div>
        </div>
      </div>
      <div class="footer">*以上信息仅供参考，以现场实际信息为准</div>
    </div>
  </div>
</template>

<script>
import { getNewData } from '@/libs/api.js'



export default {
  filters: {
    time(val) {
      if (!val) return '--分--秒'
      val = new Date(val)
      let h = val.getHours()
      let m = val.getMinutes()
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
  },
  data() {
    return {
      src: 'https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=1977218188&quality=0',
      player: null,
      l_time_list: [],
      loading: false,
      color: '#c5141e',
      headerImg: 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head.png'
    }
  },
  mounted() {
    let group = this.$route.query.group
    if (group == 'A') { 
      this.color = '#0065AC' 
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head1.png'
    } else if (group == 'B') { 
      this.color = '#7D4697'
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head2.png'
    } else if (group == 'C') { 
      this.color = '#F5AC3C'
      this.headerImg = 'https://oss.mcloud.moveclub.cn/2025/g100/arrive-head3.png'
    }
    let self = this
    this.getList()
    setInterval(() => {
      if (self.loading) {
        return
      }
      self.getList()
    }, 5000)
  }, 
  methods: {
    getList() {
      this.loading = true
      let group = this.$route.query.group
      getNewData(this.$route.query).then(res=>{
        if(res.status == 200) {
          let arr = []
          res.data.forEach(item=>{
            if(group && item.info.numberid1.indexOf(group) !== -1) {
              item.info.numberid1 = this.formatId(item.info.numberid1)
              arr.push(item)
            } else if(!group) {
              item.info.numberid1 = this.formatId(item.info.numberid1)
              arr.push(item)
            }
            
          })
          this.l_time_list = arr.slice(0, 6)
        }
        this.loading = false
      })
    },
    formatId(id) {
      if (id.length < 3) return id; // 防止过短
      const prefix = id.slice(0, -2);
      const suffix = id.slice(-2);
      return `${prefix}-${suffix}`;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style lang="less" scoped>
.map-pc {
  display: flex;

  .arrive_list {
    position: relative;
    .head {
      margin-bottom: 26px;
      img {
        width: 100%;
      }
    }
    .body {
      .item {
        padding: 15px 40px 15px 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.even {
          background: #b1111a;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
        }
        &.first {
          position: relative;
          margin-bottom: 40px;
          .info {
            margin-left: -25px;
            position: relative;
            z-index: 1;
          }
          .l-time {
            font-size: 44px;
            font-weight: bold;
          }
          .img {
            position: absolute;
            background: url(../../assets/first-bg.png) no-repeat center left/cover;
            width: 330px;
            height: 148px;
            z-index: 0;
            top: 8px;
            left: -42px;
          }
        }
        .info {
          color: #fff;
          font-size: 32px;
          .g-name {
            font-weight: bold;
            width: 226px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .l-time {
          font-size: 28px;
          color: #fff;
        }
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px 0;
      text-align: center;
      background: transparent;
      color: #fff;
      box-shadow: none
    }
  }
}
</style>
